import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";
import {WorkStatusAppService} from "../../services/workStatusAppService";
import logger from "../../core/utils/logger";

export const getWorkStatusReqeustsInOrg=createAsyncThunk(
    'workStatusApp/getWorkStatusRequestsInOrg',
    async(_, {rejectWithValue})=>{
        try{
            const response=await WorkStatusAppService.getWorkStatusRequestsInOrg();
            logger.log("Work status requests response:", JSON.stringify(response));
            return response;
        }catch(error){
            logger.error('Error:', error);
            const errorMessage =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                'Error getting work status requests';
            throw new Error(errorMessage);
        }
    }
);
export const getWorkStatusRequestByUserId=createAsyncThunk(
    'workStatusApp/getWorkStatusRequestByUserId',
    async(_,{rejectWithValue})=>{
        try{
            const response=await WorkStatusAppService.getWorkStatusRequestByUserId();
            logger.log("Work status requests response:", JSON.stringify(response));
            return response;
        }catch(error){
            logger.error('Error:', error);
            const errorMessage =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                'Error getting work status requests';
            throw new Error(errorMessage);
        }
    }
);
export const insertWorkStatusRequest=createAsyncThunk(
    'workStatusApp/insertWorkStatusRequest',
    async({workStatusRequest},{rejectWithValue})=>{
        try{
            const response=await WorkStatusAppService.insertWorkStatusRequest(workStatusRequest);
            logger.log("Work status requests response:", JSON.stringify(response));
            return response;
        }catch(error){
            logger.error('Error:', error);
            const errorMessage =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                'Error inserting work status request';
            throw new Error(errorMessage);
        }
    }
);
export const updateWorkStatusRequest=createAsyncThunk(
    'workStatusApp/updateWorkStatusRequest',
    async({workStatusRequest},{rejectWithValue})=>{
        try{
            const response=await WorkStatusAppService.updateWorkStatusRequest(workStatusRequest);
            logger.log("Work status requests response:", JSON.stringify(response));
            return response;
        }catch(error){
            logger.error('Error:', error);
            const errorMessage =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                'Error updating work status request';
            throw new Error(errorMessage);
        }
    }
);
export const deleteWorkStatusRequest=createAsyncThunk(
    'workStatusApp/deleteWorkStatusRequest',
    async({workStatusRequestId},{rejectWithValue})=>{
        try{
            const response=await WorkStatusAppService.deleteWorkStatusRequest(workStatusRequestId);
            logger.log("Work status requests response:", JSON.stringify(response));
            if(response){
                return workStatusRequestId;
            }else{
                throw new Error('Error deleting work status request');
            }
        }catch(error){
            logger.error('Error:', error);
            const errorMessage =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                'Error deleting work status request';
            throw new Error(errorMessage);
        }
    }
);
export const approveWorkStatusRequest=createAsyncThunk(
    'workStatusApp/approveWorkStatusRequest',
    async({workStatusRequestId},{rejectWithValue})=>{
        try{
            const response=await WorkStatusAppService.approveWorkStatusRequest(workStatusRequestId);
            logger.log("Work status requests response:", JSON.stringify(response));
            return response;
        }catch(error){
            logger.error('Error:', error);
            const errorMessage =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                'Error approving work status request';
            throw new Error(errorMessage);
        }
    }
);
export const calculateHolidayDays=createAsyncThunk(
    'workStatusApp/calculateHolidayDays',
    async({dateFrom, dateTo},{rejectWithValue})=>{
        try{
            const response=await WorkStatusAppService.calculateHolidayDays(dateFrom, dateTo);
            return response;
        }catch(error){
            logger.error('Error:', error);
            const errorMessage =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                'Error calculating holiday days';
            throw new Error(errorMessage);
        }
    }
);
export const rejectWorkStatusRequest=createAsyncThunk(
    'workStatusApp/rejectWorkStatusRequest',
    async({workStatusRequestId},{rejectWithValue})=>{
        try{
            const response=await WorkStatusAppService.rejectWorkStatusRequest(workStatusRequestId);
            logger.log("Work status requests response:", JSON.stringify(response));
            return response;
        }catch(error){
            logger.error('Error:', error);
            const errorMessage =
                (error.response && error.response.data && error.response.data.message) ||
                error.message ||
                'Error rejecting work status request';
            throw new Error(errorMessage);
        }
    }
);
const initialState = {
    workStatusRequests:[],
    loading:false,
    error:null,
    suggestedDays:null,
    suggestedWorkDays:[],
    calculationLoading:false
};
const workStatusAppSlice=createSlice({
    name:'workStatusApp',
    initialState,
    reducers:{
        clearWorkStatusAppState:(state)=>{
            state.workStatusRequests=[];
            state.loading=false;
            state.error=null;
            state.suggestedDays=null;
            state.suggestedWorkDays=[];
            state.calculationLoading=false;
        },
        clearCalculation:(state)=>{
            state.suggestedDays=null;
            state.suggestedWorkDays=[];
            state.calculationLoading=false;
        }
    },
    extraReducers:(builder)=>{
        builder.addCase(getWorkStatusReqeustsInOrg.pending,(state)=>{
            state.loading=true;
            state.error=null;
        });
        builder.addCase(getWorkStatusReqeustsInOrg.fulfilled,(state,action)=>{
            state.workStatusRequests=action.payload;
            state.loading=false;
            state.error=null;
        });
        builder.addCase(getWorkStatusReqeustsInOrg.rejected,(state,action)=>{
            state.workStatusRequests=[];
            state.loading=false;
            state.error=action.error.message;
        });
        builder.addCase(getWorkStatusRequestByUserId.pending,(state)=>{
            state.loading=true;
            state.error=null;
        });
        builder.addCase(getWorkStatusRequestByUserId.fulfilled,(state,action)=>{
            state.workStatusRequests=action.payload;
            state.loading=false;
            state.error=null;
        });
        builder.addCase(getWorkStatusRequestByUserId.rejected,(state,action)=>{
            state.workStatusRequests=[];
            state.loading=false;
            state.error=action.error.message;
        });
        builder.addCase(insertWorkStatusRequest.pending,(state)=>{
            state.loading=true;
            state.error=null;
        });
        builder.addCase(insertWorkStatusRequest.fulfilled,(state,action)=>{
        const exists = state.workStatusRequests.some(req => req.id === action.payload.id);
        if (!exists) {
            state.workStatusRequests.push(action.payload);
        }
            state.loading=false;
            state.error=null;
        });
        builder.addCase(insertWorkStatusRequest.rejected,(state,action)=>{
            //state.workStatusRequests=[];
            state.loading=false;
            state.error=action.error.message;
        });
        builder.addCase(updateWorkStatusRequest.pending,(state)=>{
            state.loading=true;
            state.error=null;
        });
        builder.addCase(updateWorkStatusRequest.fulfilled,(state,action)=>{
        const updated = action.payload;
        const index = state.workStatusRequests.findIndex(item => item.id === updated.id);
        if (index !== -1) {
            state.workStatusRequests[index] = updated; // Replace the item
        }
            state.loading=false;
            state.error=null;
        });
        builder.addCase(updateWorkStatusRequest.rejected,(state,action)=>{
            //state.workStatusRequests=[];
            state.loading=false;
            state.error=action.error.message;
        });
        builder.addCase(deleteWorkStatusRequest.pending,(state)=>{
            state.loading=true;
            state.error=null;
        });
        builder.addCase(deleteWorkStatusRequest.fulfilled,(state,action)=>{
            const deletedId = action.payload;
            state.workStatusRequests = state.workStatusRequests.filter(item => item.id !== deletedId);
            state.loading=false;
            state.error=null;
        });
        builder.addCase(deleteWorkStatusRequest.rejected,(state,action)=>{
            state.loading=false;
            state.error=action.error.message;
        });
        builder.addCase(approveWorkStatusRequest.pending,(state)=>{
            state.loading=true;
            state.error=null;
        });
        builder.addCase(approveWorkStatusRequest.fulfilled,(state,action)=>{
        const updated = action.payload;
        const index = state.workStatusRequests.findIndex(item => item.id === updated.id);
        if (index !== -1) {
            state.workStatusRequests[index] = updated; // Replace the item
        }
            state.loading=false;
            state.error=null;
        });
        builder.addCase(approveWorkStatusRequest.rejected,(state,action)=>{
            //state.workStatusRequests=[];
            state.loading=false;
            state.error=action.error.message;
        });
        builder.addCase(rejectWorkStatusRequest.pending,(state)=>{
            state.loading=true;
            state.error=null;
        });
        builder.addCase(rejectWorkStatusRequest.fulfilled,(state,action)=>{
        const updated = action.payload;
        const index = state.workStatusRequests.findIndex(item => item.id === updated.id);
        if (index !== -1) {
            state.workStatusRequests[index] = updated; // Replace the item
        }
        });
        builder.addCase(rejectWorkStatusRequest.rejected,(state,action)=>{

            state.loading=false;
            state.error=action.error.message;
        });
        builder.addCase(calculateHolidayDays.pending,(state)=>{
            state.calculationLoading=true;
        });
        builder.addCase(calculateHolidayDays.fulfilled,(state,action)=>{
            state.suggestedDays=action.payload.suggestedDays;
            state.suggestedWorkDays=action.payload.workDays || [];
            state.calculationLoading=false;
        });
        builder.addCase(calculateHolidayDays.rejected,(state,action)=>{
            state.suggestedDays=null;
            state.suggestedWorkDays=[];
            state.calculationLoading=false;
        });
    }
});
export const {clearWorkStatusAppState, clearCalculation}=workStatusAppSlice.actions;
export default workStatusAppSlice.reducer;
